import { render, staticRenderFns } from "./LocationInfoPage.vue?vue&type=template&id=a0d4f1a8&scoped=true&"
import script from "./LocationInfoPage.vue?vue&type=script&lang=js&"
export * from "./LocationInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./LocationInfoPage.vue?vue&type=style&index=0&id=a0d4f1a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d4f1a8",
  null
  
)

export default component.exports